export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/GeoLocationButton.4f8971ce.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};